var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFolderSimpleDotted = function SvgIconFolderSimpleDotted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 7.5V6.25h4.664L11.4 8.3a1 1 0 0 0 1.2-1.6L9.796 4.6l-.002-.002A1.76 1.76 0 0 0 8.75 4.25H3.75A1.75 1.75 0 0 0 2 6v1.5a1 1 0 0 0 2 0M4 18a1 1 0 1 0-2 0v.806A1.693 1.693 0 0 0 3.694 20.5H8.25a1 1 0 1 0 0-2H4zM11 19.5a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1M22 14.25a1 1 0 1 0-2 0v4.25h-1.25a1 1 0 1 0 0 2h1.584A1.665 1.665 0 0 0 22 18.834zM14.75 7.5a1 1 0 0 1 1-1h4.5A1.75 1.75 0 0 1 22 8.25v2.25a1 1 0 1 1-2 0v-2h-4.25a1 1 0 0 1-1-1M4 11.25a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0z"
  }))));
};
export default SvgIconFolderSimpleDotted;